<template>
  <div class="">
    <!-- <div class="pl-subheading pl-bold mv2 ml2">Integrations</div> -->
    <pl-spinner v-if="loading" />
    <div v-else class="justify-center">
      <div class="bg-gray-50 w-full p-3 mb-5 text-gray-400">
        <span v-if="getProfile.role === 'teacher'">
          You can connect your Parlay account to your account from other
          Learning Management Systems at the school / district.
        </span>
        <span v-else>
          You can connect your Parlay account to your account from other
          Learning Management Systems that your school or teacher uses in your
          classroom.
        </span>
      </div>
      <div>
        <profile-integration-card
          :integration="classroom_integration"
          :title="google_classroom_title"
          :icon="google_classroom_icon"
          :code="google_classroom_code"
          :memberships="memberships"
        />
      </div>
      <!-- <div v-for="(integration, key) in getProviders" v-bind:key="key">
        <profile-integration-card
          :integration="integration"
          :title="integration.name"
          :icon="integration.icon_url"
          :code="integration.id"
          :memberships="memberships"
        />
      </div> -->
    </div>
    <google-classroom-modal
      v-if="google_classroom_modal"
      :courses="courses"
      @close="google_classroom_modal = false"
    />
    <disconnect-google-classroom-modal
      v-if="show_disconnect_classroom_modal"
      @close="show_disconnect_classroom_modal = false"
    />
    <courses-to-import-modal
      v-if="show_courses_to_import_modal"
      :courses="courses_to_import"
      :integration="integration"
      :loadingCourses="loading_courses"
      :memberships="memberships"
      @close="show_courses_to_import_modal = false"
    />
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import googleClassroomModal from 'components/modals/googleClassroomModal';
  import disconnectGoogleClassroomModal from 'components/modals/disconnectGoogleClassroomModal';
  import coursesToImportModal from 'components/modals/coursesToImportModal';
  import profileIntegrationCard from './profileIntegrationCard';
  import URLconfigs from 'services/apiConfigs';
  import { EventBus } from 'utils/event-bus';
  import adminServices from 'services/admin/adminServices';
  import getBillingInformation from 'services/account/getBillingInformation';

  export default {
    components: {
      profileIntegrationCard,
      googleClassroomModal,
      disconnectGoogleClassroomModal,
      coursesToImportModal,
    },
    data() {
      return {
        loading: false,
        google_classroom_connected: false,
        loading_to_disconnect: false,
        google_classroom_course_name: 'Findmore to change',
        google_classroom_modal: false,
        show_disconnect_classroom_modal: false,
        integrations: [],
        show_integration_modal: false,
        update_roster: false,
        memberships: {},
        selected_integration: {},
        google_classroom_title: 'Google Classroom',
        google_classroom_icon: '/static/google_class_round.png',
        google_classroom_code: 'google-classroom',
        classroom_integration: {
          name: 'Google Classroom',
        },
        show_courses_to_import_modal: false,
        courses_to_import: [],
        integration: {},
        loading_courses: false,
      };
    },
    computed: {
      ...mapGetters(['getProfile', 'getProviders']),
      is_teacher() {
        return this.getProfile.role === 'teacher';
      },
    },
    methods: {
      getEdlinkProviders() {
        this.loading = true;
        this.$store
          .dispatch('getSsoProviders')
          .then(() => {
            this.loading = false;
          })
          .catch((err) => {
            console.error(err);
            this.loading = false;
          });
      },
      closeIntegrationModal() {
        this.show_integration_modal = false;
        if (this.$route.query.integrationID) {
          delete this.$route.query.integrationID;
        }
      },
    },
    created() {
      if (this.getProfile.role === 'teacher') {
        getBillingInformation().then((res) => {
          const { memberships } = res.data;
          this.memberships = memberships;
        });
      }
    },
    async mounted() {
      this.getEdlinkProviders();
      if (this.$route.query.code) {
        const code = this.$route.query.code;
        const redirect_uri = `${URLconfigs.uiURL}/profile/integrations`;
        this.$router.replace({ query: null });
        const payload = {
          code,
          redirect_uri,
        };
        await this.$store
          .dispatch('generateSsoTokens', payload)
          .then(async (data) => {
            const edlink_integrations = this.getProfile.edlink_integrations;
            const { integration } = data;

            this.$store.dispatch('updateProviders', {
              integration_id: integration.id,
              connect: true,
            });
            const { data: profile_integration } =
              await adminServices.setSsoIntegrationProfile(integration.id);

            edlink_integrations.push(profile_integration);
            await this.$store.dispatch('updateAccount', {
              edlink_integrations,
            });

            if (
              this.is_teacher &&
              profile_integration &&
              integration &&
              integration.id
            ) {
              this.loading_courses = true;
              this.show_courses_to_import_modal = true;
              await this.$store.dispatch('addUserToClassesSharingRule', {
                integration_id: integration.id,
                payload: {
                  user_id: profile_integration.user_id,
                  email: profile_integration.email,
                },
              });
              const courses = await this.$store
                .dispatch('getSsoCoursesFromLms', {
                  integration_id: integration.id,
                })
                .catch(() => (this.loading_courses = false));
              this.loading_courses = false;
              if (courses && courses.length) {
                this.courses_to_import = courses;
              }
              this.integration = profile_integration;
            }
          });
      }
      EventBus.$on('disconnected-integration-account', (integration_id) => {
        this.$store.dispatch('updateProviders', {
          integration_id,
          connect: false,
        });
      });
    },
    beforeDestroy() {
      EventBus.$off('disconnected-integration-account');
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
  .header
    color : pl-secondary
    font-size : 16px
</style>



// WEBPACK FOOTER //
// integrationsTab.vue?1e1c334d